<template>
    <div>

        <rkm-form
            ref="FormOutros"
            show-legend
        >

            <rkm-area
                type="fieldset"
                title="Salário Mínimo"
            >
                <FormSalarioMinimo
                    :data="data"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Supervisor"
            >
                <FormSupervisor
                    :data="data"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Atendimento por CBO"
            >
                <FormPermissao
                    :data="data"
                />
            </rkm-area>
        </rkm-form>
    </div>
</template>

<script>

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

// Components
import FormSalarioMinimo from './components/salario-minimo/Form'
import FormSupervisor from './components/supervisor/Form'
import FormPermissao from './components/permissao/Form'

export default {
    components: {
        FormSalarioMinimo,
        FormSupervisor,
        FormPermissao,
    },
    methods: {
        async validate() {

            return true
        }
    },
    mixins: [ formats, repository, object, ],
    props: {
        data: { type: Object, required: false },
    }
}
</script>